import * as React from 'react';

const SvgIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    fill="none"
    viewBox="0 0 24 25"
  >
    <circle
      cx="12"
      cy="12.5"
      r="12"
      fill="#fff"
      className="success-circle-svg"
    ></circle>
    <path
      fill="#27B973"
      fillRule="evenodd"
      d="M14.743 9.716a.737.737 0 0 1 1.052 1.03l-3.92 4.901-.019.02a.736.736 0 0 1-1.041 0l-2.6-2.598a.737.737 0 0 1 1.042-1.042l2.056 2.056 3.41-4.345z"
      clipRule="evenodd"
      className="path-svg"
    ></path>
  </svg>
);

export default SvgIcon;
